import { Divider, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ControlCamera from "@mui/icons-material/ControlCamera";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionIcon from "@mui/icons-material/Description";
import ListIcon from "@mui/icons-material/List";
import { NavLink } from "react-router-dom";
import RoutePaths from "../../../routes/route-paths";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import localisations from "../../localisation";
import useStyles from "./styles";
import InventoryIcon from '@mui/icons-material/Inventory';
import ReportIcon from '@mui/icons-material/Report';

function NavBar() {
    const classes = useStyles();
    const {
        home,
        partitions,
        createPartition,
        adjustmentAllocation,
        movementAllocation,
        createPreAlert,
        StockTransferImport,
        manageNodes,
        productSearch,
        consistencyCheck
    } = localisations.navigation;

    const reloadRoute = (path: string) => ({ pathname: RoutePaths.ReloadRoute, state: path });
    const activeCheck = (path: string) => ((_: any, location: any) => location.pathname.startsWith(path));

    return (
        <>
            <ListItemButton component={NavLink} exact to={RoutePaths.Root} activeClassName={classes.active}>
                <ListItemIcon>
                    <DashboardIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={home} />
            </ListItemButton>

            <ListItemButton component={NavLink} to={reloadRoute(RoutePaths.ManageNodes)} isActive={activeCheck(RoutePaths.ManageNodes)} activeClassName={classes.active}>
                <ListItemIcon>
                    <AccountTreeIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={manageNodes} />
            </ListItemButton>

            <ListItemButton component={NavLink} to={reloadRoute(RoutePaths.Partitions)} isActive={activeCheck(RoutePaths.Partitions)} activeClassName={classes.active}>
                <ListItemIcon>
                    <ListIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={partitions} />
            </ListItemButton>

            <ListItemButton component={NavLink} to={reloadRoute(RoutePaths.CreatePartition)} isActive={activeCheck(RoutePaths.CreatePartition)} activeClassName={classes.active}>
                <ListItemIcon>
                    <AddCircleIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={createPartition} />
            </ListItemButton>

            <ListItemButton component={NavLink} to={reloadRoute(RoutePaths.AdjustmentAllocation)} isActive={activeCheck(RoutePaths.AdjustmentAllocation)} activeClassName={classes.active}>
                <ListItemIcon>
                    <ControlCamera className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={adjustmentAllocation} />
            </ListItemButton>

            <ListItemButton component={NavLink} to={reloadRoute(RoutePaths.MovementAllocation)} isActive={activeCheck(RoutePaths.MovementAllocation)} activeClassName={classes.active}>
                <ListItemIcon>
                    <SyncAltIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={movementAllocation} />
            </ListItemButton>

            <ListItemButton component={NavLink} to={reloadRoute(RoutePaths.Product)} isActive={activeCheck(RoutePaths.Product)} activeClassName={classes.active}>
                <ListItemIcon>
                    <InventoryIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={productSearch} />
            </ListItemButton>

            <ListItemButton component={NavLink} to={reloadRoute(RoutePaths.CreatePreAlert)} isActive={activeCheck(RoutePaths.CreatePreAlert)} activeClassName={classes.active}>
                <ListItemIcon>
                    <DescriptionIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={createPreAlert} />
            </ListItemButton>

            <ListItemButton component={NavLink} to={reloadRoute(RoutePaths.ConsistencyCheck)} isActive={activeCheck(RoutePaths.ConsistencyCheck)} activeClassName={classes.active}>
                <ListItemIcon>
                    <ReportIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={consistencyCheck} />
            </ListItemButton>

            <Divider />

            <ListItemButton component={NavLink} to={reloadRoute(RoutePaths.StockTransferImport)} isActive={activeCheck(RoutePaths.StockTransferImport)} activeClassName={classes.active}>
                <ListItemIcon>
                    <CloudUploadIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText primary={StockTransferImport} />
            </ListItemButton>
        </>
    );
}

export default NavBar;
